import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";

const RecentBlog = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [recentPosts, setRecentPosts] = useState([]);
    const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes in milliseconds

    useEffect(() => {
        // Check if recent posts data is available in localStorage
        const cachedData = JSON.parse(localStorage.getItem('recentPostsData'));

        if (cachedData) {
            const { data, timestamp } = cachedData;

            // Check if the cached data has expired (older than 30 minutes)
            const currentTime = Date.now();
            if (currentTime - timestamp < cacheExpiryTime) {
                // If not expired, use the cached data
                setRecentPosts(data);
            } else {
                // If expired, clear the cache and fetch new data
                localStorage.removeItem('recentPostsData');
                fetchRecentPosts();
            }
        } else {
            // If no cache, fetch data from the API
            fetchRecentPosts();
        }
    }, []);

    const fetchRecentPosts = () => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_RECENT_BLOGS;

        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => {
                const newData = response.data;
                // Save the fetched data along with the current timestamp in localStorage
                localStorage.setItem('recentPostsData', JSON.stringify({
                    data: newData,
                    timestamp: Date.now(),
                }));
                setRecentPosts(newData);
            })
            .catch(error => {
                console.error("Error fetching API", error);
            });
    };

    return (
        <div className="widget mb-45 wow fadeInUp">
            <h3 className="sidebar__widget--title mb-30">Recent Post</h3>
            {recentPosts.map((recentPost, index) => {
                return (
                    <Link className={'text-decoration-none'} to={`/blog/details/${recentPost?.slug}`} key={index}>
                        <div className="sidebar--widget__post mb-20">
                            <div className="">
                                <img className="img-fluid" width={50} src={`${backendBaseUrl}${recentPost?.image}`} alt="" />
                            </div>
                            <div className="px-2 text-dark">
                                <h6 className="">
                                    {recentPost?.title}
                                </h6>
                                <small><i className="far fa-clock"></i> {new Date(recentPost?.published_date).toLocaleDateString('bn-BD', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}</small>
                            </div>
                        </div>
                    </Link>
                );
            })}
        </div>
    );
}

export default RecentBlog;
